import { Button } from '@digdir/designsystemet-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useCreateV2025Registration } from '../../../../registrationV2025/hooks/useRegistrationV2025Form/useCreateV2025Registration';
import { SoknadSteg } from '../../../../../components/registering/utils/registerEnums';
import { SimpleBuildingRegistration } from '../../../../../types/building';
import { useGetUserInputReadOnly } from '../../../../registration/hooks/useGetUserInput';
import { fromUserInputToFormData } from '../../../../registrationV2025/pages/omBoligen/form/utils/dataMapper';
import { updateRegistration as updateRegistrationAction } from '../../../../../store/registration/actions';

interface Props {
  registrering: SimpleBuildingRegistration;
}

export const CreateTiltakRegistrationButton: React.FC<Props> = ({ registrering }) => {
  const { t } = useTranslation();
  const { createRegistration, createIsLoading } = useCreateV2025Registration();
  const { userInput } = useGetUserInputReadOnly(registrering.registreringId);
  const formData = fromUserInputToFormData({ userInput, registreringId: registrering.registreringId });
  const dispatch = useDispatch();

  const onCreateTiltak = () => {
    // TODO: Remove redux dependency. Move registration copy logic to backend.
    dispatch(updateRegistrationAction({ userInput }));

    createRegistration({
      formData,
      soknadSteg: SoknadSteg.Steg2,
      soknadId: registrering.soknadId
    });
  };

  return (
    <Button onClick={onCreateTiltak} loading={createIsLoading}>
      {t('screens.energiplan.components.tiltak.createButton')}
    </Button>
  );
};
